import axios from "axios";
import routes from "../../configs/api";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";

const validateWebsiteCoupon = (data) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  return axios
    .post(routes.VALIDATE_WEBSITE_COUPON, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data);
};

export default validateWebsiteCoupon;
